module.exports = __webpack_public_path__ + "static/media/amazon.5873b059.jpg";